/* HomeKind v2 page behaviour (phase 2), ported from the concept's script.
   Everything is scoped to .hkv2c markup and does nothing on a page without it.
   Cart work goes through HKCartQ (hk-cart-core-v1.js), which adds the free
   Starter Pack and applies pack pricing in the same request and fires
   cart:update for the drawer. No timers run on pages that do not need them. */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var H = window.HKV2 || { packs: {} };
  var route = H.route || "";
  var reduce = function () { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; };
  var smooth = function () { return reduce() ? "auto" : "smooth"; };
  var money = function (cents) { var v = cents / 100; return "$" + (v % 1 ? v.toFixed(2) : String(v)); };
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- cart ---------- */
  function json(url, body) {
    return fetch(url, { method: body ? "POST" : "GET", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function announce(cart, sections) {
    var ev; try { ev = new Event("cart:update", { bubbles: true }); } catch (e) { ev = document.createEvent("Event"); ev.initEvent("cart:update", true, false); }
    ev.detail = { resource: cart, sourceId: "hkv2", data: { source: "hkv2", itemCount: cart.item_count, sections: sections } };
    document.dispatchEvent(ev);
  }
  function openDrawer() { if (window.HKCart) { try { window.HKCart.open(); return; } catch (e) {} } location.href = "/cart"; }
  /* Same request shape as Horizon's product form: ask for the cart sections back
     so the drawer is morphed with fresh markup even when it was empty. */
  /* v2.3: adds go through HKCartQ (hk-cart-core-v1.js), the one serial queue that
     reads a fresh cart, turns 2 or 3 loose bottles into the pack price and adds the
     free Starter Pack in the same request, then fires cart:update once. The direct
     add below is only the fallback for a page where that script failed to load. */
  function addToCart(items, btn) {
    if (btn) { btn.disabled = true; btn.setAttribute("aria-busy", "true"); }
    /* Resolves true when the add went through, false when it failed (the error is
       shown in the toast here), so callers can tidy up only after a real add. */
    if (window.HKCartQ) {
      return window.HKCartQ.add(items)
        .then(function () { openDrawer(); return true; })
        .catch(function (err) { toast((err && (err.description || err.message)) || "That did not go into the cart. Please try again."); if (window.HKCart) window.HKCart.refresh(); return false; })
        .then(function (ok) { if (btn) { btn.disabled = false; btn.removeAttribute("aria-busy"); } return ok; });
    }
    var ids = $$("cart-items-component").map(function (c) { return c.dataset.sectionId; }).filter(Boolean);
    var body = { items: items }; if (ids.length) { body.sections = ids.join(","); body.sections_url = location.pathname; }
    var sections;
    return json("/cart/add.js", body)
      .then(function (r) { sections = r && r.sections; return json("/cart.js"); })
      .then(function (cart) { announce(cart, sections); openDrawer(); return true; })
      .catch(function (err) { toast((err && (err.description || err.message)) || "That did not go into the cart. Please try again."); return false; })
      .then(function (ok) { if (btn) { btn.disabled = false; btn.removeAttribute("aria-busy"); } return ok; });
  }
  document.addEventListener("click", function (e) {
    var q = e.target.closest && e.target.closest("[data-quickadd]");
    if (q) { var p = H.packs[q.getAttribute("data-quickadd")]; if (p && p.variant) { e.preventDefault(); addToCart([{ id: p.variant, quantity: 1 }], q); } return; }
    var a = e.target.closest && e.target.closest('[data-hkv2-add="starter"]');
    if (a && H.kit) { e.preventDefault(); addToCart([{ id: H.kit, quantity: 1 }], a); return; }
    /* v2.7 (audit fix): the accessory pages (sections/hkv2-accessory.liquid) add their one variant */
    var av = e.target.closest && e.target.closest("[data-hkv2-add-vid]");
    if (av && +av.getAttribute("data-hkv2-add-vid") > 0) { e.preventDefault(); addToCart([{ id: +av.getAttribute("data-hkv2-add-vid"), quantity: 1 }], av); return; }
    var s = e.target.closest && e.target.closest("[data-scrollto]");
    if (s) {
      var t = document.getElementById(s.getAttribute("data-scrollto"));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: smooth(), block: "start" }); var h2 = $("h2", t); if (h2) { h2.setAttribute("tabindex", "-1"); h2.focus({ preventScroll: true }); } }
    }
  });

  var tt;
  function toast(m) {
    var t = $("#hkv2-toast");
    if (!t) { t = document.createElement("div"); t.id = "hkv2-toast"; t.className = "toast"; t.setAttribute("role", "status"); var w = document.createElement("div"); w.className = "hkv2c hkv2-toastwrap"; w.appendChild(t); document.body.appendChild(w); }
    t.textContent = m; t.hidden = false; clearTimeout(tt); tt = setTimeout(function () { t.hidden = true; }, 5000);
  }

  /* ---------- jobs accordions ---------- */
  $$(".hkv2c [data-acc]").forEach(function (acc) {
    var img = acc.parentNode.querySelector("[data-jobimg]");
    var btns = $$("h3 > button", acc);
    btns.forEach(function (b) {
      b.addEventListener("click", function () {
        var open = b.getAttribute("aria-expanded") === "true";
        btns.forEach(function (o) { o.setAttribute("aria-expanded", "false"); var p = document.getElementById(o.getAttribute("aria-controls")); if (p) p.hidden = true; });
        if (!open) {
          b.setAttribute("aria-expanded", "true");
          var panel = document.getElementById(b.getAttribute("aria-controls"));
          if (panel) { panel.hidden = false; var pi = $("img", panel); if (img && pi) { img.src = pi.currentSrc || pi.src; img.srcset = pi.srcset || ""; img.alt = pi.alt; } }
        }
      });
    });
  });

  /* ---------- FAQ (round 6): one accordion pattern on every route, heading > button + region ---------- */
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest(".hkv2c .fq button");
    if (!b) return;
    var open = b.getAttribute("aria-expanded") === "true";
    b.setAttribute("aria-expanded", open ? "false" : "true");
    var p = document.getElementById(b.getAttribute("aria-controls")); if (p) p.hidden = open;
  });

  /* ---------- reviews filter ---------- */
  var rf = $$(".hkv2c .rfilter button");
  if (rf.length) {
    var pg = $('.hkv2c [data-page="reviews"]');
    rf.forEach(function (b) {
      b.addEventListener("click", function () {
        var k = b.getAttribute("data-kind");
        rf.forEach(function (o) { o.setAttribute("aria-pressed", o === b ? "true" : "false"); });
        $$(".rev[data-kind]", pg).forEach(function (r) { r.hidden = k !== "all" && r.getAttribute("data-kind") !== k; });
        var th = $("#revTestH", pg); if (th) th.hidden = !(k === "all" || k === "tester");
        var pair = $(".revs.pair", pg); if (pair) pair.hidden = k === "tester";
        var shown = $$(".rev[data-kind]", pg).filter(function (r) { return !r.hidden && !r.closest("[hidden]"); }).length;
        var live = $("#revLive", pg); if (live) live.textContent = "Showing " + shown + " " + (k === "all" ? "" : (k === "tester" ? "gifted tester " : "customer ")) + "reviews";
      });
    });
  }

  /* ---------- shop helper ---------- */
  var helper = $(".hkv2c #helper");
  if (helper) {
    var help = function () {
      var v = function (n) { var c = $("input[name=" + n + "]:checked", helper); return c ? +c.value : 0; };
      var s = v("h1") + v("h2") + v("h3"), k = s >= 3 ? 3 : (s >= 1 ? 2 : 1);
      var why = v("h2") ? ' Floors take the biggest dose on the chart, <span class="nb">20 to 30ml</span> <span class="nb">(2 to 3 capfuls)</span> per mop bucket.' : "";
      var two = v("h3") ? " One of each scent if you like." : " Two of the same scent, one for the kitchen and one for the bathroom.";
      var txt = { 1: "<b>1 bottle, $39.99.</b> Plenty for a small home that mostly wipes benches and glass.", 2: "<b>The Kitchen and Bathroom Set.</b> $70 for two (save $9.98 on two singles), free post and a free Starter Pack." + two + why, 3: "<b>The Stock Up Set.</b> $99 for three (save $20.97 on three singles), free Express Post and a free Starter Pack." + why }[k];
      $("#helpRes", helper).innerHTML = txt;
      var go = $("#helpGo", helper); if (go && H.packs[k]) go.href = H.packs[k].url;
      /* round 6 (S18): built only from her answers and the chart doses, no months of use claim */
      var mIn = $("input[name=h4]:checked", helper), m = mIn ? +mIn.value : 1, y = m * 12, sv = $("#helpSave", helper);
      if (sv) sv.textContent = "At " + (m === 3 ? "3 or more" : m) + " a month you spend about $" + Math.round(y * 4) + " to $" + Math.round(y * 7) + " a year on sprays. Mixed at home, the same sprays cost about $" + Math.round(y * 0.40) + "." + (v("h2") ? " Mopping most weeks adds about " + (52 * 25 / 1000).toFixed(1) + "L of concentrate a year, which is where the second bottle goes." : "");
      var ans = ["one", "two", "three_plus"][v("h1")] + "_bath,floors_" + (v("h2") ? "yes" : "no") + "," + (v("h3") ? "both_scents" : "one_scent") + "," + m + "_a_month,pack_" + k;
      var tg = $("[data-help-tags]"); if (tg) tg.value = "newsletter,hkv2-chart,hkv2-quiz,quiz-" + ans.split(",").join(",quiz-");
    };
    $$("input", helper).forEach(function (i) { i.addEventListener("change", help); });
    helper.addEventListener("submit", function (e) { e.preventDefault(); });
    help();
  }

  /* ---------- calculator ---------- */
  $$(".hkv2c [data-calc]").forEach(function (root) {
    var id = root.getAttribute("data-calc"), yr = 12;
    var q = function (k) { return $('[data-c="' + k + '"]', root); };
    var f = function () {
      var pc = $("input[name=cp_" + id + "]:checked", root), mc = $("input[name=cm_" + id + "]:checked", root);
      if (!pc || !mc) return;
      var p = +pc.value, m = +mc.value, pk = H.packs[p] || {}, price = (pk.price || [0, 3999, 7000, 9900][p]) / 100, n = Math.floor(p * 1000 / m), c = price / n * 100;
      var per = c >= 99.5 ? "$" + (c / 100).toFixed(2) : Math.round(c) + "c";
      q("per").textContent = per; q("yr").textContent = yr;
      var hk = yr * c / 100, hkS = hk >= 1 ? "$" + hk.toFixed(2) : Math.round(hk * 100) + "c";
      q("year").textContent = "About $" + (yr * 4) + " to $" + (yr * 7) + " a year on supermarket sprays, against about " + hkS + " in HomeKind";
      q("price").textContent = "$" + (price % 1 ? price.toFixed(2) : price);
      q("pnote").innerHTML = (p === 1 ? "this pack, by Express Post." : "this pack, post free.") + ' Makes <span class="nb">up to ' + n + " spray bottles</span>.";
      q("say").textContent = per + " a spray bottle. About $" + (yr * 4) + " to $" + (yr * 7) + " a year on supermarket sprays, against about " + hkS + ".";
      var go = q("go"); go.textContent = "Choose this pack · $" + (price % 1 ? price.toFixed(2) : price); if (pk.url) go.href = pk.url;
    };
    $$("input", root).forEach(function (i) { i.addEventListener("change", f); });
    $$("[data-y]", root).forEach(function (b) { b.addEventListener("click", function () { yr = Math.max(4, Math.min(52, yr + (+b.getAttribute("data-y")))); f(); }); });
    $$("form", root).forEach(function (fm) { fm.addEventListener("submit", function (e) { e.preventDefault(); }); });
    f();
  });

  /* ---------- moving benefit strips (.nasties) ---------- */
  $$(".hkv2c .nasties ul").forEach(function (ul) {
    if (ul.classList.contains("marq")) return;
    var items = $$("li", ul); if (!items.length) return;
    items.forEach(function (li) { var c = li.cloneNode(true); c.setAttribute("aria-hidden", "true"); ul.appendChild(c); });
    var label = (ul.getAttribute("aria-label") || "").replace(/, scrolls sideways$/, "");
    ul.classList.add("marq"); ul.removeAttribute("tabindex"); ul.setAttribute("role", "list"); if (label) ul.setAttribute("aria-label", label);
    ul.style.setProperty("--marq-dur", Math.max(24, items.length * 4.5) + "s");
    var band = ul.closest(".nasties");
    band.addEventListener("touchstart", function () { band.classList.add("hold"); }, { passive: true });
    band.addEventListener("touchend", function () { setTimeout(function () { band.classList.remove("hold"); }, 1500); }, { passive: true });
  });

  /* ---------- moving strip pause button (round 5), remembered for the visit ---------- */
  var marqStop = false; try { marqStop = sessionStorage.getItem("hk_marq") === "off"; } catch (e) {}
  var setMarq = function () { $$(".hkv2c .nasties").forEach(function (n) { n.classList.toggle("stopped", marqStop); var x = $(".marq-btn", n); if (x) { x.setAttribute("aria-pressed", marqStop ? "true" : "false"); x.setAttribute("aria-label", marqStop ? "Play the moving list" : "Pause the moving list"); } }); };
  $$(".hkv2c .marq-btn").forEach(function (b) { b.addEventListener("click", function () { marqStop = b.getAttribute("aria-pressed") !== "true"; try { sessionStorage.setItem("hk_marq", marqStop ? "off" : "on"); } catch (e) {} setMarq(); }); });
  setMarq();

  /* ---------- seasonal gifting line: 1 Nov to 24 Dec and 1 to 10 May, Sydney date ---------- */
  var seasonOn = function () { try { var o = {}; new Intl.DateTimeFormat("en-AU", { timeZone: "Australia/Sydney", month: "numeric", day: "numeric" }).formatToParts(new Date()).forEach(function (x) { o[x.type] = +x.value; }); return o.month === 11 || (o.month === 12 && o.day <= 24) || (o.month === 5 && o.day <= 10); } catch (e) { return false; } };
  $$(".hkv2c [data-season]").forEach(function (el) { el.hidden = !seasonOn(); });

  /* ---------- ad to page message match: approved keys only, URL text never rendered ---------- */
  /* round 6 (S11): a hook speaks only on the page the ad landed on, only while the pack on
     screen is the hook's pack; the one bottle page rewrites its headline only */
  var NB = " ";
  var HOOKS = {
    static_1: { hook: "Two bottles, $70. Free post and a free Starter Pack.", sub: "One litre makes up to 100 spray bottles, about 35c each when you buy two.", pack: 2 },
    static_nopost: { hook: "Two bottles, $70. Free post and a free Starter Pack.", sub: "One litre makes up to 100 spray bottles, about 35c each when you buy two.", pack: 2 },
    video_v2: { hook: "One bottle. Every job in the house.", sub: "10ml" + NB + "(1" + NB + "capful) in a litre of water. About 40c a spray bottle." },
    video12: { hook: "One bottle. Every job in the house.", sub: "10ml" + NB + "(1" + NB + "capful) in a litre of water. About 40c a spray bottle." },
    review_v1: { hook: "“Showers and mirrors are SHINING.”", cite: "HomeKind customer", sub: "Spray the shower screen, leave it a couple of minutes, wipe. The same bottle does the mirror." },
    h_100: { hook: "1L makes up to 100 litres of spray.", sub: "10ml" + NB + "(1" + NB + "capful) per litre of water. About 40c a spray bottle.", img: "scale" }
  };
  var urlPack = (function () { try { var p = +new URLSearchParams(location.search).get("pack"); return p >= 1 && p <= 3 ? p : null; } catch (e) { return null; } })();
  try {
    var qs = new URLSearchParams(location.search), had = sessionStorage.getItem("hk_src"), src0 = {};
    ["utm_source", "utm_campaign", "utm_content", "hk_ad", "fbclid"].forEach(function (k) { if (qs.get(k)) src0[k] = qs.get(k); });
    src0.landing = route;
    /* first touch is kept: write only when this URL carries a source, or nothing is stored yet */
    if (Object.keys(src0).length > 1 || !had) sessionStorage.setItem("hk_src", JSON.stringify(src0));
    var src = JSON.parse(sessionStorage.getItem("hk_src") || "{}") || {};
    var hk = src.hk_ad && HOOKS[src.hk_ad] ? src.hk_ad : (src.utm_content && HOOKS[src.utm_content] ? src.utm_content : null);
    var HK = hk && src.landing === route ? HOOKS[hk] : null;
    var pgEl = $(".hkv2c [data-page]"), pkNow = +((pgEl && pgEl.getAttribute("data-pack")) || 0) || urlPack || { septic: 2, glass: 2, save: 3, "one-bottle": 2 }[route] || 0;
    if (HK && HK.pack && HK.pack !== pkNow) HK = null;
    if (HK) {
      var ph = $(".hkv2c #pHook"), ps = $(".hkv2c #pHookSub"), pc = $(".hkv2c #pHookCite");
      if (ph && ps) {
        ph.textContent = HK.hook; ps.textContent = HK.sub; ps.hidden = false;
        if (pc) { pc.textContent = HK.cite || ""; pc.hidden = !HK.cite; }
        var pj = $(".hkv2c #pJust"); if (pj) pj.hidden = true;
        if (HK.img) window.__hkv2GalTo = HK.img;
      }
      var hh = $(".hkv2c #preH1") || $(".hkv2c [data-hook-h]"), hs = route === "one-bottle" ? null : $(".hkv2c [data-hook-s]");
      if (hh && !ph) {
        hh.textContent = HK.hook; if (hs) hs.textContent = HK.sub;
        if (HK.cite) { var ct = document.createElement("cite"); ct.className = "hook-cite"; ct.textContent = HK.cite; hh.insertAdjacentElement("afterend", ct); }
      }
    }
  } catch (e) {}

  /* ---------- dispatch line, Sydney time, weekends and NSW public holidays skipped ----------
     17 Oct 2026 (urgency pass): the line sits under Add to cart (.hkdx, sections/hkv2-pdp.liquid).
     Before the cut off on a business day: "Order in 1h 59m, dispatched today", counted to 2pm Sydney
     time MINUS a 15 minute checkout allowance (CHECKOUT_MIN), so someone who starts checkout when the
     line runs out has still paid by the real 2pm cut off (ACL review 17 Oct 2026). Counted to the real
     instant with Intl, so the visitor's own time zone and daylight saving never matter, and floored,
     so it never promises more time than is left. Under a minute left counts as after the cut off.
     Past the last year in the holiday list it falls back to the plain promise (never a guess). After 2pm, or on a weekend or holiday: "Order now, dispatched tomorrow" or the next
     business day's name. Hours and minutes only, repainted each minute from the real clock, so it
     never resets. It matches the site promise "Order by 2pm on a business day and it ships the
     same day". Hidden while the chosen mix is sold out (sync() below). The theme
     setting "Show the dispatch countdown" (HomeKind stock and dispatch) removes it entirely.
     The pure logic is window.HKDX, between the HKDX markers, so tests run this exact code in node. */
  /* HKDX:BEGIN */
  var HKDX = (function () {
    var TZ = "Australia/Sydney", CUT_H = 14, CHECKOUT_MIN = 15;
    /* OWNER: NSW public holidays, from nsw.gov.au/about-nsw/public-holidays (checked 16 Oct 2026).
       UPDATE THIS LIST EVERY YEAR (add next year's dates before December). Weekend dates are listed
       for completeness; the "additional day" Mondays and Tuesdays are what matter. Bank Holiday
       (first Monday in August) is NOT a public holiday and Australia Post opens, so it is left out. */
    var HOLS = [
      "2026-01-01", "2026-01-26", "2026-04-03", "2026-04-04", "2026-04-05", "2026-04-06", "2026-04-25", "2026-04-27",
      "2026-06-08", "2026-10-05", "2026-12-25", "2026-12-26", "2026-12-28",
      "2027-01-01", "2027-01-26", "2027-03-26", "2027-03-27", "2027-03-28", "2027-03-29", "2027-04-25", "2027-04-26",
      "2027-06-14", "2027-10-04", "2027-12-25", "2027-12-26", "2027-12-27", "2027-12-28"
    ];
    var LAST_YEAR = +HOLS[HOLS.length - 1].slice(0, 4);
    var DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var pad = function (n) { return (n < 10 ? "0" : "") + n; };
    var fmt = null;
    /* Sydney wall clock for an instant */
    var syd = function (ms) {
      fmt = fmt || new Intl.DateTimeFormat("en-AU", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23" });
      var o = {}; fmt.formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = p.value; });
      return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24, mi: +o.minute, s: +o.second };
    };
    /* calendar maths on plain dates (UTC midnight), so no time zone can shift a day */
    var cal = function (y, m, d) { return new Date(Date.UTC(y, m - 1, d)); };
    var key = function (c) { return c.getUTCFullYear() + "-" + pad(c.getUTCMonth() + 1) + "-" + pad(c.getUTCDate()); };
    var biz = function (c) { var w = c.getUTCDay(); return w !== 0 && w !== 6 && HOLS.indexOf(key(c)) < 0; };
    /* the instant when Sydney's wall clock reads y-m-d h:mi (corrected twice for the UTC offset) */
    var at = function (y, m, d, h, mi) {
      var want = Date.UTC(y, m - 1, d, h, mi), g = want;
      for (var i = 0; i < 2; i++) { var p = syd(g); g += want - Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi, p.s); }
      return g;
    };
    var text = function (now) {
      var p = syd(now), today = cal(p.y, p.m, p.d);
      /* no holiday list for this year (or for the next business day's year): plain promise only */
      var plain = { today: false, minutes: 0, next: "", text: "Order by 2pm on a business day for same day dispatch" };
      if (p.y > LAST_YEAR) return plain;
      if (biz(today)) {
        var left = at(p.y, p.m, p.d, CUT_H, 0) - CHECKOUT_MIN * 60000 - now;
        if (left >= 60000) {
          var mins = Math.floor(left / 60000), h = Math.floor(mins / 60), mm = mins % 60;
          var span = h ? h + "h" + (mm ? " " + mm + "m" : "") : mm + "m";
          return { today: true, minutes: mins, next: key(today), text: "Order in " + span + ", dispatched today" };
        }
      }
      var n = cal(p.y, p.m, p.d), gap = 0;
      do { n.setUTCDate(n.getUTCDate() + 1); gap++; } while (!biz(n) && gap < 60);
      if (n.getUTCFullYear() > LAST_YEAR) return plain;
      var when = gap === 1 ? "tomorrow" : (gap <= 6 ? DAYS[n.getUTCDay()] : DAYS[n.getUTCDay()] + " " + n.getUTCDate() + " " + MONTHS[n.getUTCMonth()]);
      return { today: false, minutes: 0, next: key(n), text: "Order now, dispatched " + when };
    };
    return { text: text, holidays: HOLS, cutoffHour: CUT_H, checkoutMinutes: CHECKOUT_MIN, lastYear: LAST_YEAR };
  })();
  /* HKDX:END */
  window.HKDX = HKDX;
  var ships = $$("[data-hkv2-ship]");
  if (ships.length) {
    var ship = function () {
      var r; try { r = HKDX.text(Date.now()); } catch (e) { return; }
      ships.forEach(function (s) { var t = $("[data-hkdx-t]", s) || s; if (t.textContent !== r.text) t.textContent = r.text; s.classList.add("is-ready"); });
    };
    ship();
    /* repaint on each minute boundary, and straight away when the tab comes back */
    var shipTick = function () { ship(); setTimeout(shipTick, 60000 - (Date.now() % 60000) + 50); };
    setTimeout(shipTick, 60000 - (Date.now() % 60000) + 50);
    document.addEventListener("visibilitychange", function () { if (!document.hidden) ship(); });
  }

  /* ---------- thanks page survey (preview only: answers stay in this browser) ---------- */
  /* round 6 (S20): native radios in .spill labels */
  $$(".hkv2c .sv-opts").forEach(function (g) {
    var key = g.getAttribute("data-sv");
    $$("input", g).forEach(function (b) {
      b.addEventListener("change", function () {
        ls(key, b.value);
        if (key === "hk_hesitation") { var other = $(".sv-other", g.parentNode) || $(".hkv2c .sv-other"); if (other) { other.hidden = !b.hasAttribute("data-other"); var so = $("#svOther"); if (!other.hidden && so) so.focus(); } }
        var done = $$(".hkv2c .sv-opts").every(function (x) { return $("input:checked", x); });
        var th = $("#svThanks"); if (th) th.textContent = done ? "Thanks. That helps more than you’d think." : "";
      });
    });
  });

  /* ---------- contact topic from ?topic= ---------- */
  var topic = $(".hkv2c #cTopic");
  if (topic) { try { var tp = new URLSearchParams(location.search).get("topic"); if (tp) { topic.value = tp; if (tp === "review") { var msg = $("#cMsg"); if (msg) msg.placeholder = "Tell us what you used it on and how it went. We publish it as written, with spelling tidied."; } } } catch (e) {} }

  /* ---------- refer link copy ---------- */
  var cr = $(".hkv2c #copyRef");
  if (cr) cr.addEventListener("click", function () { var i = $("#refLink"); try { navigator.clipboard.writeText(i.value).then(function () { toast("Link copied."); }, function () { i.select(); }); } catch (e) { i.select(); } });

  /* ---------- product page ---------- */
  var pdp = $(".hkv2c [data-hkv2-pdp]");
  if (pdp) {
    var variants = []; try { variants = JSON.parse($("#hkv2-variants").textContent); } catch (e) {}
    var idIn = $('input[name="id"]', pdp), atcBtn = $(".atc", pdp), atcL = $(".atc-l", pdp), atcS = $("[data-atc-s]", pdp);
    var scBox = $("#bScents", pdp), packK = (scBox && +scBox.getAttribute("data-k")) || $$(".srow", pdp).length || 1;
    var NB0 = { 1: "1 bottle", 2: "2 bottles", 3: "3 bottles" };
    /* v2.4: one chooser per bottle, always open. The chosen values map to a variant
       ignoring bottle order: the exact order if it is in stock, else any in stock
       variant holding the same scents, so the pack added always matches the chips. */
    var chosen = function () { var out = []; $$(".srow", pdp).forEach(function (row, i) { var c = $("input:checked", row); out[i] = c ? c.value : null; }); return out; };
    var sortedKey = function (a) { return a.slice().sort().join("|"); };
    var pickVariant = function (o) {
      var exact = variants.filter(function (x) { return o.every(function (val, i) { return x.options[i] === val; }); })[0];
      if (exact && exact.available) return exact;
      var key = sortedKey(o);
      return variants.filter(function (x) { return x.available && sortedKey(x.options.slice(0, o.length)) === key; })[0] || exact || null;
    };
    var shortName = function (s) { return String(s).split(" + ")[0]; };
    var scentLine = function (o) {
      if (o.length === 1) return o[0];
      var cnt = {}, ord = []; o.forEach(function (s) { if (!cnt[s]) { cnt[s] = 0; ord.push(s); } cnt[s]++; });
      return ord.map(function (s) { return cnt[s] + " × " + shortName(s); }).join(", ");
    };
    /* v2.7: the add-on tick boxes under the buy box (spare spray bottle, Refresh Pack).
       Ticked boxes ride in the same HKCartQ.add call as the bottle, the button shows
       the combined price, and the ticks clear once the add has gone through so a
       second Add to cart does not add a second spray bottle by accident. */
    var xBoxes = function () { return $$("[data-hkv2-extra]", pdp.parentNode || document).filter(function (b) { return +b.getAttribute("data-hkv2-extra") > 0; }); };
    var xOn = function () { return xBoxes().filter(function (b) { return b.checked; }); };
    var xItems = function () { return xOn().map(function (b) { return { id: +b.getAttribute("data-hkv2-extra"), quantity: 1 }; }); };
    var xCents = function () { var t = 0; xOn().forEach(function (b) { t += +b.getAttribute("data-price") || 0; }); return t; };
    /* 17 Oct 2026 (urgency pass v2): sold out scents can be chosen. Then the main button turns into
       "Email me when it's back" (it opens the back in stock form, snippets/hkv2-bis, Klaviyo) and the
       line under it names an in stock scent to try instead. A mix whose scents are each in stock but
       cannot be made up (two of a scent with one bottle left) says so and offers the same swap. The
       dispatch line (.hkdx) shows only while the chosen mix can be bought. No count is ever shown. */
    var bisBox = function () { return $("#bisd"); };
    var notifyFor = null;
    var openBis = function (scents) {
      var d = bisBox(); if (!d) return; d.open = true;
      $$('input[name="hk_bis"]', d).forEach(function (c) { if (scents.indexOf(c.getAttribute("data-scent")) > -1) c.checked = true; });
      d.scrollIntoView({ behavior: smooth(), block: "center" });
      setTimeout(function () { var em = $("#bisEmail"); if (em) em.focus({ preventScroll: true }); }, reduce() ? 0 : 350);
    };
    var picked = function () { return $$(".srow", pdp).map(function (row) { return $("input:checked", row); }); };
    var soldIn = function (i) { return !!(i && i.hasAttribute("data-soldout")); };
    /* the in stock scent that turns this choice into a mix that can be bought, swapping only the
       bottles that are the problem (sold out ones first, else the repeated scent's extra bottles) */
    var swapFor = function (o, ins) {
      var stock = []; $$(".srow", pdp)[0] && $$("input[data-opt]", $$(".srow", pdp)[0]).forEach(function (x) { if (!x.hasAttribute("data-soldout") && stock.indexOf(x.value) < 0) stock.push(x.value); });
      var bad = []; ins.forEach(function (x, i) { if (soldIn(x)) bad.push(i); });
      if (!bad.length) { var seen = {}; o.forEach(function (s, i) { if (seen[s]) bad.push(i); seen[s] = 1; }); }
      for (var c = 0; c < stock.length; c++) {
        var t = o.slice(); bad.forEach(function (i) { t[i] = stock[c]; });
        var tv = pickVariant(t); if (tv && tv.available) return { scent: stock[c], to: t };
      }
      return null;
    };
    var NBSP = " ";
    var dxOn = function (on) { $$(".hkv2c .hkdx").forEach(function (d) { d.classList.toggle("is-off", !on); d.setAttribute("aria-hidden", on ? "false" : "true"); }); };
    var alt = $("[data-hkalt]", pdp.parentNode || document);
    /* one short line, so it takes the dispatch line's place without moving the page (CRO review 17 Oct) */
    var altSet = function (sw) {
      if (!alt) return;
      alt.textContent = "";
      if (!sw) { alt.classList.remove("is-on"); return; }
      var b = document.createElement("button"); b.type = "button"; b.className = "hkalt-try";
      b.textContent = "Or try " + sw.scent;
      b.addEventListener("click", function () { sw.to.forEach(function (val, i) { var r = $$(".srow", pdp)[i]; var inp = r && $$("input[data-opt]", r).filter(function (x) { return x.value === val; })[0]; if (inp) inp.checked = true; }); sync(); atcBtn.focus({ preventScroll: true }); });
      alt.appendChild(b);
      alt.classList.add("is-on");
    };
    var stickyBuy = function (txt) { var sb = $(".hkv2-stickywrap #sticky .btn-buy"); if (sb && sb.textContent !== txt) sb.textContent = txt; };
    var sync = function () {
      var o = chosen();
      if (o.some(function (x) { return x === null; })) return;
      var ins = picked(), v = pickVariant(o);
      if (atcS) atcS.textContent = scentLine(o);
      notifyFor = null;
      if (!v || !v.available) {
        var sold = [], where = []; ins.forEach(function (x, i) { if (soldIn(x)) { if (sold.indexOf(x.value) < 0) sold.push(x.value); where.push(shortName(x.value) + (packK > 1 ? ", bottle " + (i + 1) : "")); } });
        var sw = swapFor(o, ins), lbl;
        if (sold.length) {
          if (bisBox()) { notifyFor = sold; lbl = "Email me when it" + "’" + "s back"; } else lbl = "Sold out";
          /* the line under the label names the sold out scent (and bottle), so the email is clearly for it */
          if (atcS) atcS.textContent = "Sold out: " + where.join(" and ");
        } else {
          /* ACL review: the cause is not certain (a bundle part or an unpublished variant could also block it), so no scent is blamed */
          lbl = "This mix isn" + "’" + "t available";
        }
        atcBtn.disabled = !notifyFor;
        atcBtn.classList.toggle("is-notify", !!notifyFor);
        if (atcL) atcL.textContent = lbl; else atcBtn.textContent = lbl;
        stickyBuy(notifyFor ? "Email me" : "Add to cart");
        dxOn(false); altSet(sw);
        return;
      }
      idIn.value = v.id;
      atcBtn.disabled = false; atcBtn.classList.remove("is-notify");
      dxOn(true); altSet(null); stickyBuy("Add to cart");
      var xn = xOn().length, xw = xn ? " + " + xn + (xn === 1 ? " extra" : " extras") : "";
      /* audit 2 nit 3: non breaking spaces around the dot so a wrapped label keeps "cart · $49.98" together */
      var lblA = "Add " + (NB0[packK] || "") + xw + " to cart · " + money(v.price + xCents());
      if (atcL) atcL.textContent = lblA; else atcBtn.textContent = lblA;
      try { var u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(history.state, "", u); } catch (e) {}
    };
    $$(".srow input", pdp).forEach(function (r) { r.addEventListener("change", sync); });
    sync();
    $$("[data-notify]").forEach(function (b) { b.addEventListener("click", function () { var want = b.getAttribute("data-notify"); openBis(want ? [want] : []); }); });
    xBoxes().forEach(function (b) { b.addEventListener("change", sync); });
    pdp.addEventListener("submit", function (e) {
      e.preventDefault();
      /* a sold out scent is chosen: the button is "Email me when it's back", never an add */
      if (notifyFor) { openBis(notifyFor); return; }
      var items = [{ id: +idIn.value, quantity: 1 }].concat(xItems());
      var r = addToCart(items, atcBtn);
      /* audit fix: the ticks clear only after a real add, so a failed add keeps her choice */
      if (r && r.then && items.length > 1) r.then(function (ok) { if (ok === false) return; xOn().forEach(function (b) { b.checked = false; }); sync(); });
    });
    var refill = $("[data-hkv2-refill]");
    /* v2.5: the cart attribute "Refill reminder" = "Yes" rides on the order; with a known
       email, hk-klaviyo-v1.js also sets hk_refill_opt_in and hk_last_scent on her profile */
    /* v2.6: the tick shows 1 to 4 month choices; "Remind in" rides on the order beside
       "Refill reminder", and the referral service sends the Klaviyo event from the paid order */
    var refillMo = $("[data-hkv2-refill-mo]");
    var months = function () { var r = refillMo && refillMo.querySelector("input:checked"); return r ? +r.value : 3; };
    var refillInfo = function () { var o = chosen().filter(function (x) { return x; }); return { scent: o[0] || "", scents: o.join(", "), pack: packK, months: months() }; };
    var saveRefill = function () {
      var on = refill.checked, n = months();
      if (refillMo) refillMo.hidden = !on;
      var a = { "Refill reminder": on ? "Yes" : "", "Remind in": on ? n + (n === 1 ? " month" : " months") : "" };
      (window.HKCartQ ? window.HKCartQ.attrs(a) : json("/cart/update.js", { attributes: a })).catch(function () {});
      if (window.HKKL) window.HKKL.refill(on, refillInfo()).catch(function () {});
    };
    if (refill) refill.addEventListener("change", saveRefill);
    if (refill && refillMo) { refillMo.addEventListener("change", saveRefill); refillMo.hidden = !refill.checked; }
    /* show what the cart already holds, so a return visit sees her tick and month */
    if (refill && window.fetch) fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (c) {
      var at = (c && c.attributes) || {};
      if (at["Refill reminder"] !== "Yes" || refill.checked) return;
      refill.checked = true;
      var n = parseInt(at["Remind in"], 10), r = refillMo && refillMo.querySelector('input[value="' + (n >= 1 && n <= 4 ? n : 3) + '"]');
      if (r) r.checked = true;
      if (refillMo) refillMo.hidden = false;
    }).catch(function () {});
  }

  /* ---------- product gallery ---------- */
  $$(".hkv2c [data-hkv2-gal]").forEach(function (gal) {
    var track = $(".gal-track", gal), slides = $$(".slide", track), th = $$(".thumbs button", gal), dots = $$(".dots button", gal), live = $("[data-gal-live]", gal), gi = 0;
    var go = function (n, quiet) {
      gi = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { var on = i === gi; s.classList.toggle("on", on); s.inert = !on; if (on) s.removeAttribute("aria-hidden"); else s.setAttribute("aria-hidden", "true"); });
      th.concat(dots).forEach(function (b) { b.removeAttribute("aria-current"); });
      if (th[gi]) th[gi].setAttribute("aria-current", "true"); if (dots[gi]) dots[gi].setAttribute("aria-current", "true");
      /* round 6: a phone chip over the photo and a desktop chip under it, both only on the first slide */
      $$(".gal-chip", gal).forEach(function (chip) { chip.hidden = gi !== 0; });
      if (!quiet && live) live.textContent = "Image " + (gi + 1) + " of " + slides.length + (th[gi] ? ": " + (th[gi].getAttribute("aria-label") || "").replace(/^Image \d+: /, "") : "");
    };
    th.forEach(function (b, i) { b.addEventListener("click", function () { go(i); }); });
    dots.forEach(function (b, i) { b.addEventListener("click", function () { go(i); }); });
    var pv = $(".galnav.prev", gal), nx = $(".galnav.next", gal);
    if (pv) pv.addEventListener("click", function () { go(gi - 1); });
    if (nx) nx.addEventListener("click", function () { go(gi + 1); });
    track.addEventListener("keydown", function (e) { if (e.key === "ArrowLeft") { e.preventDefault(); go(gi - 1); } else if (e.key === "ArrowRight") { e.preventDefault(); go(gi + 1); } });
    var tx = null, ty = null;
    track.addEventListener("touchstart", function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
    track.addEventListener("touchend", function (e) { if (tx === null) return; var d = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty; if (Math.abs(d) > 40 && Math.abs(d) > Math.abs(dy) * 1.5) go(gi + (d < 0 ? 1 : -1)); tx = null; });
    /* the h_100 ad hook opens the gallery on the scale photo */
    if (window.__hkv2GalTo) { var gx = slides.map(function (s) { var im = $("img", s); return im && im.src.indexOf("hkv2-" + window.__hkv2GalTo + ".") > -1; }).indexOf(true); if (gx > -1) go(gx, true); }
  });

  /* ---------- sticky buy bar on the ad pages and articles ---------- */
  var route = H.route || "";
  var ANG = { septic: 2, glass: 2, save: 3, "one-bottle": 2 };
  /* round 6 (S11): /pages/one-bottle?pack=N adds that pack directly from the strip, the
     inline card and the sticky bar, with "or compare all three packs" as the link */
  var preDirect = route === "one-bottle" && !!urlPack && !!(H.packs[urlPack] || {}).variant;
  if (preDirect) {
    var dP = H.packs[urlPack], dLbl = "Add " + (dP.n || "") + " · " + money(dP.price || 0), CDN = "https://cdn.shopify.com/s/files/1/0775/9645/9207/files/hkv2-";
    var STRIP = {
      1: '<b>One bottle $39.99 by Express Post. Free $19.99 Starter Pack. 30 day Keep the Bottle Guarantee.</b> <span class="os-more">Or two for $70 with free post.</span>',
      2: '<b>Two bottles $70 with free post. Free $19.99 Starter Pack. 30 day Keep the Bottle Guarantee.</b> <span class="os-more">Or one bottle for $39.99.</span>',
      3: '<b>Three bottles $99, $33 a bottle, free Express Post. Free $19.99 Starter Pack. 30 day Keep the Bottle Guarantee.</b> <span class="os-more">Or two for $70 with free post.</span>'
    };
    var IB = { 1: ["One bottle, $39.99. Starter Pack included.", "Express Post. About 40c a spray bottle."], 2: ["Two bottles, $70, free post. Starter Pack included.", "$35 a bottle, about 35c a spray bottle."], 3: ["Three bottles, $99, free Express Post. Starter Pack included.", "$33 a bottle, about 33c a spray bottle."] };
    var btnH = '<button type="button" class="btn btn-buy" data-quickadd="' + urlPack + '" style="min-height:48px;font-size:var(--t-md)">' + dLbl + "</button>";
    var cmpH = '<button type="button" class="cmp-link" data-scrollto="preOffer">or compare all three packs</button>';
    var sImg = $(".hkv2c #preStripImg"); if (sImg) { sImg.src = CDN + "pack" + urlPack + "_t.jpg?width=240"; sImg.removeAttribute("srcset"); }
    var sTxt = $(".hkv2c [data-strip]"); if (sTxt) sTxt.innerHTML = STRIP[urlPack];
    var psb = $(".hkv2c .ps-btn"); if (psb) psb.innerHTML = btnH + cmpH;
    var ib = $$(".hkv2c #reasons .inline-buy:not(.ib-guar)")[0];
    if (ib) {
      var ibi = $("img", ib); if (ibi) { ibi.src = CDN + "pack" + urlPack + "_t.jpg?width=200"; ibi.removeAttribute("srcset"); }
      var ibh = $(".ib-h", ib); if (ibh) ibh.textContent = IB[urlPack][0];
      var ibs = $(".muted.small", ib); if (ibs) ibs.textContent = IB[urlPack][1];
      var ibl = $("button.link", ib);
      if (ibl) { var sp = document.createElement("span"); sp.style.cssText = "display:flex;flex-wrap:wrap;gap:4px 14px;align-items:center"; sp.innerHTML = btnH + ibl.outerHTML.replace(">See the packs<", ">or compare all three packs<"); ibl.replaceWith(sp); }
    }
  }
  if (ANG[route] || route === "article") {
    var pk = route === "one-bottle" && urlPack ? urlPack : (ANG[route] || 1), P = H.packs[pk] || {}, F = "https://cdn.shopify.com/s/files/1/0775/9645/9207/files/hkv2-";
    var wrap = document.createElement("div"); wrap.className = "hkv2c hkv2-stickywrap";
    var sub = route === "one-bottle" ? "Free $19.99 Starter Pack" : { 1: "From $39.99, with a free Starter Pack", 2: "Free post · Free Starter Pack", 3: "Free Express Post · Free Starter Pack" }[pk];
    /* round 6 (S14): "2 bottles · $70", pack first */
    var name = route === "article" ? "One bottle. Every job." : (route === "one-bottle" ? (P.n || "") + " · " + money(P.price || 0) + (pk === 1 ? "" : " · " + (pk === 3 ? "Free Express Post" : "Free post")) : (P.n || "") + " · " + money(P.price || 0));
    var label = route === "article" || (route === "one-bottle" && !preDirect) ? "See the packs" : "Add " + (P.n || "") + " · " + money(P.price || 0);
    wrap.innerHTML = '<div class="sticky" aria-hidden="true"><img src="' + F + 'pack' + pk + '_t.jpg?width=120" alt="" id="stImg"><span class="t"><b id="stName"></b><span id="stSub"></span></span><button type="button" class="btn btn-buy" tabindex="-1"></button></div>';
    document.body.appendChild(wrap);
    var st = $(".sticky", wrap); $("b", st).textContent = name; $(".t span", st).textContent = sub; var sbtn = $("button", st); sbtn.textContent = label;
    sbtn.addEventListener("click", function () {
      if (route === "article") { location.href = "/collections/all"; return; }
      if (route === "one-bottle" && !preDirect) { var t = document.getElementById("preOffer"); if (t) t.scrollIntoView({ behavior: smooth(), block: "start" }); return; }
      if (P.variant) addToCart([{ id: P.variant, quantity: 1 }], sbtn);
    });
    var anchor = $(".hkv2c [data-sticky-anchor]") || $(".hkv2c #reason1") || $(".hkv2c #reasons") || $(".hkv2c .article h1");
    var stopAt = $(".hkv2c [data-angle-cards]") || $(".hkv2c #preOffer") || $(".hkv2c #articleEnd");
    var inView = function (el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight; };
    var last = null;
    var check = function () {
      var on = !!anchor && anchor.getBoundingClientRect().bottom < 0 && !inView(stopAt) && !$("dialog[open], #Details-menu-drawer-container[open]") && (!$("#welcome") || $("#welcome").hidden);
      if (on === last) return; last = on;
      st.classList.toggle("show", on); st.setAttribute("aria-hidden", on ? "false" : "true"); sbtn.tabIndex = on ? 0 : -1;
      /* the bar's real height (safe area padding included) lifts the back to top button 12px clear of it */
      document.documentElement.style.setProperty("--hk-bar-h", on ? (st.offsetHeight || 72) + "px" : "0px");
    };
    window.addEventListener("scroll", check, { passive: true }); window.addEventListener("resize", check, { passive: true }); check();
  }

  /* ---------- welcome pop up (arm A) ---------- */
  var wel = $("#welcome");
  if (wel) {
    var INFO = ["home", "how", "inside", "story", "calculator", "impact", "faq", "journal", "article"], SALES = ["product", "shop", "septic", "glass", "save", "one-bottle"], NEVER = ["thanks", "refer", "gift", "terms", "privacy", "returns", "contact", "cart", ""];
    var PRESET = { glass: "Shower screen and glass", septic: "The whole house", save: "The whole house" };
    var SUBS = { "Shower screen and glass": "plus the shower screen fix that ends streaks", "Kitchen grease": "plus the rangehood fix for kitchen grease", "Floors": "plus the right dose for your mop bucket" };
    var scrim = $("#welScrim"), tabw = $("#welTabW"), tab = $("#welTab"), tabx = $("#welTabX"), form = $("#hkv2-wel-form"), tagsIn = $("[data-wel-tags]"), W = { open: false, done: false, trigger: null, timer: null, timeUp: false, t0: Date.now(), lastY: 0, tabOff: false };
    if (form) { form.classList.add("wel-step"); form.setAttribute("data-wstep", "2"); form.hidden = true; form.style.display = "grid"; form.style.gap = "12px"; form.noValidate = true; }
    var imgLoad = function () { var i = $("#welImg"); if (i && i.hasAttribute("data-src")) { var u = i.getAttribute("data-src").split("?")[0]; i.srcset = u + "?width=200 200w, " + u + "?width=480 480w, " + u + "?width=800 800w"; i.sizes = "(max-width:560px) 88px, 200px"; i.src = u + "?width=480"; i.removeAttribute("data-src"); } };
    var state = function () { try { return JSON.parse(ls("hk_pop") || "{}") || {}; } catch (e) { return {}; } };
    var fromEmail = /(^|[?&])utm_medium=email(&|$)/.test(location.search);
    var isTouch = function () { return window.matchMedia("(max-width:900px), (hover:none)").matches; };
    var drawerOpen = function () { return !!$("dialog[open], #Details-menu-drawer-container[open]"); };
    /* 1 Oct 2026: one pop up for everyone (the "free Starter Pack" version, was test variant B). The copy is in
       snippets/hkv2-welcome.liquid; nothing is assigned or stored for it. Sign ups carry the profile property
       hk_popup_variant "B" (so they can be compared with older sign ups) and hk_popup_views (how many times this
       browser saw the pop up). Each showing publishes the Shopify customer event "hk_popup_shown". */
    var POPV = "B";
    var popViews = function (add) { var n = 0; try { n = parseInt(localStorage.getItem("hk_popn"), 10) || 0; if (add) { n += 1; localStorage.setItem("hk_popn", String(n)); } } catch (e) {} return n; };
    var popShown = function (auto) {
      if (W.popCounted) return; W.popCounted = true;
      popViews(true);
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish("hk_popup_shown", { variant: POPV, route: route, auto: !!auto }); } catch (e) {}
    };
    var allowed = function () { var s = state(); if (W.open || W.done || s.signed) return false; if (s.closed && Date.now() - s.closed < 14 * 864e5) return false; if (fromEmail || drawerOpen()) return false; return NEVER.indexOf(route) < 0; };
    var step = function (n, focus) { $$(".wel-step", wel).forEach(function (s) { s.hidden = s.getAttribute("data-wstep") !== String(n); });
      /* round 6 (S09): the photo sits beside the eyebrow and heading of the step on screen */
      var wim = $("#welImg"), wpo = $('[data-wstep="' + n + '"] .po', wel); if (wim && wpo && wim.parentNode !== wpo) wpo.insertBefore(wim, wpo.firstChild);
      wel.setAttribute("data-step", n); wel.setAttribute("aria-labelledby", (n <= 2 ? "welEb" + n + " " : "") + "welH" + n); if (W.open && focus !== false) { var h = $("#welH" + n); if (h) h.focus({ preventScroll: true }); } };
    var setAns = function (a) {
      W.ans = a; if (a) ls("hk_quiz", a);
      $("#welSub").textContent = "Your free dilution chart, " + (SUBS[a] || "plus a dose for every room, on one page") + ".";
      if (tagsIn) tagsIn.value = "newsletter,hkv2-welcome,hkv2-arm-A,hkv2-pop-" + POPV + (a ? ",quiz-" + a.toLowerCase().replace(/[^a-z]+/g, "_") : "") + (route ? ",entry-" + route : "");
    };
    var tabCheck = function () {
      var s = state(), ok = !!(s.closed && !s.signed && !W.open && !W.tabOff && NEVER.indexOf(route) < 0 && SALES.indexOf(route) < 0 && !drawerOpen());
      tabw.hidden = !ok; /* round 6 (S15): the X shows on desktop too */
    };
    var openWel = function (force) {
      if (!force && !allowed()) return;
      clearTimeout(W.timer); W.trigger = document.activeElement; W.open = true;
      imgLoad(); wel.hidden = false; scrim.hidden = false; tabw.hidden = true; document.body.style.overflow = "hidden";
      popShown(!force);
      var pre = PRESET[route];
      if (pre) { setAns(pre); step(2, false); } else { setAns(""); step(1, false); }
      wel.focus({ preventScroll: true });
    };
    var closeWel = function () {
      W.open = false; W.done = true; wel.hidden = true; scrim.hidden = true; document.body.style.overflow = "";
      var s = state(); if (!s.signed) { s.closed = Date.now(); ls("hk_pop", JSON.stringify(s)); }
      tabCheck();
      /* focus goes back to what opened it, else the side tab, else the page (never left on a hidden control) */
      if (W.trigger && W.trigger !== document.body && document.body.contains(W.trigger) && W.trigger.getClientRects().length) W.trigger.focus(); else if (!tabw.hidden) tab.focus(); else if (document.activeElement && document.activeElement !== document.body && wel.contains(document.activeElement)) document.activeElement.blur();
    };
    $$("[data-ans]", wel).forEach(function (b) { b.addEventListener("click", function () { setAns(b.getAttribute("data-ans")); step(2); }); });
    var welNo = $("#welNo"); if (welNo) welNo.addEventListener("click", function () { closeWel(); }); /* "No thanks, just browsing" closes */
    /* v2.5: the flow's hk_quiz and hk_entry values */
    var QZ = { "Shower screen and glass": "glass", "Kitchen grease": "kitchen", "Floors": "floors", "The whole house": "whole" };
    var smsForm = $("#welSmsForm");
    /* audit 2 Oct (hCaptcha over the done step): #hkv2-wel-form is a real Shopify customer form, so Shopify's
       spam protection (storefront-forms-hcaptcha) hooks its submit event and could open an image puzzle even
       though the sign up goes to Klaviyo and nothing is posted. #welGo is now type="button": the click and the
       Enter key call welSend(null), so no submit event exists for the captcha to hook. A real submit (the
       fallback when the Klaviyo script is missing or its call fails) still goes through Shopify's own check. */
    var welSend = function (e) {
      var stop = function () { if (e) { e.preventDefault(); e.stopImmediatePropagation(); } };
      var em = $("#welEmail");
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value.trim())) { stop(); em.setCustomValidity("Enter an email address like name@example.com"); em.reportValidity(); return; }
      em.setCustomValidity("");
      if (W.sending) { stop(); return; }
      var s = state(); s.signed = 1; ls("hk_pop", JSON.stringify(s)); ls("hk_offer_arm", "A"); ls("hk_entry", route);
      if (!window.HKKL || form.getAttribute("data-hk-native")) { /* the real Shopify form posts and the page reloads with the success flag */
        if (!e) { form.setAttribute("data-hk-native", "1"); if (form.requestSubmit) form.requestSubmit(); else HTMLFormElement.prototype.submit.call(form); }
        return;
      }
      /* v2.5: straight to Klaviyo (Email List, email consent); the Shopify post is the fallback */
      stop();
      W.sending = true;
      var go = $("#welGo"), err = $("#welErr"), lbl = go ? go.textContent : "";
      if (err) err.hidden = true;
      if (go) { go.disabled = true; go.setAttribute("aria-busy", "true"); go.textContent = "Sending"; }
      window.HKKL.subscribe({ email: em.value, source: "HomeKind site popup", props: { hk_quiz: QZ[W.ans] || "", hk_entry: (route === "septic" || route === "save") ? route : "", hk_offer_arm: "A", hk_entry_page: route, hk_popup_variant: POPV, hk_popup_views: popViews() || 1 } }).then(function () {
        W.sending = false; W.email = em.value.trim();
        step(smsForm ? 3 : 4);
      }, function () {
        W.sending = false;
        form.setAttribute("data-hk-native", "1");
        if (go) { go.disabled = false; go.removeAttribute("aria-busy"); go.textContent = lbl; }
        try { if (form.requestSubmit) form.requestSubmit(); else HTMLFormElement.prototype.submit.call(form); } catch (x) { if (err) { err.textContent = "That did not go through. Please check your email and try again."; err.hidden = false; } }
      });
    };
    if (form) {
      /* capture on window, so this runs before any other submit listener on the page */
      window.addEventListener("submit", function (e) { if (e.target === form) welSend(e); }, true);
      var welGo = $("#welGo"), welEm = $("#welEmail");
      if (welGo) welGo.addEventListener("click", function (e) { if (welGo.type === "submit") return; e.preventDefault(); welSend(null); });
      if (welEm) welEm.addEventListener("keydown", function (e) { if (e.key !== "Enter" || e.isComposing) return; e.preventDefault(); welSend(null); });
    }
    if (smsForm) {
      var smsErr = $("#welSmsErr");
      $("#welNoSms").addEventListener("click", function () { step(4); });
      smsForm.addEventListener("submit", function (e) {
        e.preventDefault();
        var box = $("#welSms"), mob = $("#welMob"), ph = window.HKKL && window.HKKL.auMobile(mob.value);
        var bad = function (m) { smsErr.textContent = m; smsErr.hidden = false; };
        if (!box.checked) return bad("Tick the box so we can text you, or tap No thanks.");
        if (!ph) return bad("Enter an Australian mobile like 0412 345 678.");
        smsErr.hidden = true;
        window.HKKL.subscribe({ email: W.email, phone: ph, sms: true, emailConsent: false, source: "HomeKind site popup SMS" }).then(function () { step(4); }, function () { bad("That did not go through. Tap No thanks and we’ll stick to email."); });
      });
    }
    var em0 = $("#welEmail"); if (em0) em0.addEventListener("input", function () { em0.setCustomValidity(""); });
    $("#welX").addEventListener("click", closeWel); $("#welDone").addEventListener("click", closeWel); scrim.addEventListener("click", closeWel);
    tab.addEventListener("click", function () { openWel(true); });
    tabx.addEventListener("click", function () { W.tabOff = true; tabCheck(); });
    document.addEventListener("keydown", function (e) {
      if (!W.open) return;
      if (e.key === "Escape") { e.preventDefault(); closeWel(); return; }
      if (e.key !== "Tab") return;
      var f = $$('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),[tabindex]:not([tabindex="-1"])', wel).filter(function (x) { return !x.closest("[hidden]") && x.getClientRects().length; });
      if (!f.length) { e.preventDefault(); wel.focus({ preventScroll: true }); return; }
      /* audit 2 Oct: straight after opening, focus is on the dialog itself (or a step heading), so
         Shift+Tab from there must wrap inside the pop up, not walk out to the page behind */
      var first = f[0], lastEl = f[f.length - 1], cur = document.activeElement, out = !cur || cur === wel || !wel.contains(cur);
      if (e.shiftKey && (out || cur === first)) { e.preventDefault(); lastEl.focus(); }
      else if (e.shiftKey && f.indexOf(cur) < 0) { e.preventDefault(); var prev = null; f.forEach(function (x) { if (x.compareDocumentPosition(cur) & 4) prev = x; }); (prev || lastEl).focus(); }
      else if (!e.shiftKey && (cur === lastEl || (out && cur !== wel))) { e.preventDefault(); first.focus(); }
      else if (!e.shiftKey && f.indexOf(cur) < 0) { e.preventDefault(); var next = null; f.forEach(function (x) { if (!next && cur !== wel && (cur.compareDocumentPosition(x) & 4)) next = x; }); (next || first).focus(); }
    });
    /* after a successful sign up the page reloads: show the done step once */
    if ($("[data-wel-posted]")) { var s0 = state(); s0.signed = 1; ls("hk_pop", JSON.stringify(s0)); W.open = true; wel.hidden = false; scrim.hidden = false; document.body.style.overflow = "hidden"; step(4, false); wel.focus({ preventScroll: true }); }
    else if (form && $(".hkv2-formerr", form)) { W.open = true; wel.hidden = false; scrim.hidden = false; step(2, false); }
    else {
      tabCheck();
      if (allowed()) {
        setTimeout(function () { if (allowed()) imgLoad(); }, 3000);
        if (INFO.indexOf(route) > -1 && !isTouch()) W.timer = setTimeout(function () { openWel(); }, 20000);
        else if (SALES.indexOf(route) > -1 && isTouch()) W.timer = setTimeout(function () { W.timeUp = true; salesCheck(); }, 45000);
      }
    }
    var salesCheck = function () {
      if (!W.timeUp || W.open) return;
      var past = false, a = $(".hkv2c .atc") || $(".hkv2c .cards");
      if (a) past = a.getBoundingClientRect().bottom < 0;
      if (past) openWel();
    };
    var busy = false;
    window.addEventListener("scroll", function () {
      if (busy) return; busy = true;
      setTimeout(function () {
        busy = false;
        var down = scrollY > W.lastY; W.lastY = scrollY; tabw.classList.toggle("hide", down && isTouch());
        if (W.open) return;
        if (INFO.indexOf(route) > -1) { if (isTouch() && (route === "article" || route === "journal")) return; var sh = document.documentElement.scrollHeight - innerHeight; if (sh > 0 && scrollY / sh >= 0.5) openWel(); }
        else if (SALES.indexOf(route) > -1 && isTouch()) salesCheck();
      }, 150);
    }, { passive: true });
    document.addEventListener("mouseout", function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && SALES.indexOf(route) > -1 && !isTouch()) { if (Date.now() - W.t0 < 10000 || scrollY < innerHeight * 0.3) return; openWel(); }
    });
    window.__hkv2Welcome = { open: function () { openWel(true); }, close: closeWel };
  }
})();
